import PatientCareServicesList from "../../components/screen/patientCare/patientCareServices/PatientCareServicesList";
import HOC from "../../components/HOC";
import PageTemplate from "../../components/common/particles.jsx/PageTemplate";
import { ThemeProvider } from "@mui/material";
import { theme } from "../../components/constants/muiTheme";

const PatientCareServicesPage = () => {
  return (
    <PageTemplate
      header="Services"
      mainComponent={
        <ThemeProvider theme={theme}>
          <PatientCareServicesList />
        </ThemeProvider>
      }
      pageRole={16}
    />
  );
};

export default HOC(PatientCareServicesPage);
